import type { ReactNode } from 'react';

export interface FooterProps {
  /** Left-side copyright / text. */
  copyright?: ReactNode;
  /** Right-side links — pass <li className="nav-item"> items. */
  children?: ReactNode;
  className?: string;
}

/** Limitless footer bar (navbar-footer): copyright on the left, optional links on the right. */
export function Footer({ copyright, children, className = '' }: FooterProps) {
  return (
    <div className={`navbar navbar-sm navbar-footer border-top ${className}`.trim()}>
      <div className="container-fluid">
        <span>{copyright}</span>
        {children && <ul className="nav">{children}</ul>}
      </div>
    </div>
  );
}
